module.exports = __webpack_public_path__ + "media/images/iconPaginateFirst__accent-b8f6963627dad12586fd2d094fe6fcef.png";